export function IAddressItem (store, address1 = "", address2 = "", suburb = "", postcode = "", state = "") {
    this.id = "-1",
    this.type = "address",
    this.is_risk_address = !!store && store.state.sessionDetails.properties.addresses.length > 0 ? false : true,
    this.is_mailing_address = !!store && store.state.sessionDetails.properties.addresses.length > 0 ? false : true,
    this.address = new IAddress(address1, address2, suburb, postcode, state)
}

export function IAddress (address1 = "", address2 = "", suburb = "", postcode = "", state = "") {
    this.address1 = address1
    this.address2 = address2
    this.suburb = suburb
    this.postcode = postcode
    this.state = state
}
